module.exports = __webpack_public_path__ + "static/media/list_xlargeFeirao.66da1676.jpg";